import httpClient from "httpClient"

const post = (request) => {
    
    const pathname = '/page/particular'
            
    return httpClient.post(pathname, request)    
}

const particular = {
    post,
}

export default particular

